var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coordRows)?_c('v-card-text',{staticClass:"px-0"},[_c('v-simple-table',{staticClass:"wgu-coordstable"},[_c('tbody',_vm._l((_vm.coordRows),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v(" "+_vm._s(key)+" ")]),_c('td',{staticClass:"val-td"},[_vm._v(" "+_vm._s(value)+" ")])])}),0)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }